var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDetalleDePlanProfesionales(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "5.2DetalleDePlan") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MANAGER",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2.2-Clientes",
    transform: "translate(-832.000000, -787.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(808.620075, 378.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(23.379925, 403.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.2DetalleDePlan",
    transform: "translate(0.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#F0F0F0",
    cx: 17.5,
    cy: 17.5,
    r: 17.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "1.2-ClientesLateralON",
    transform: "translate(11.000000, 9.000000)",
    stroke: "#FE8D27",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4531544,4.3677103 C10.4531544,6.77931345 8.49791818,8.73542059 6.0854441,8.73542059 C3.67384095,8.73542059 1.71860473,6.77931345 1.71860473,4.3677103 C1.71860473,1.95610714 3.67384095,0 6.0854441,0 C8.49791818,0 10.4531544,1.95610714 10.4531544,4.3677103 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1721075,17.6 L0,17.6 L0,14.9593424 C0,11.6741972 2.66243078,9.01176645 5.94670507,9.01176645 L6.2245315,9.01176645 C9.50967672,9.01176645 12.1721075,11.6741972 12.1721075,14.9593424 L12.1721075,17.6 Z",
    id: "Stroke-3"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetalleDePlanProfesionales);
export default __webpack_public_path__ + "static/media/DetalleDePlanProfesionales.6af4896cfb5499c68c9deb96f2563046.svg";
export { ForwardRef as ReactComponent };